/* eslint-disable */
import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
// chakra imports
import { Box, Flex, HStack, Text, useColorModeValue, Tooltip } from "@chakra-ui/react";
import { pricingService } from "../../../services/pricingService";
import { getRoutes } from '../../../routes';
import { getBusinessSlug } from "../../../utils/slugify";

export function SidebarLinks(props) {
  //   Chakra color mode
  let location = useLocation();
  let activeColor = useColorModeValue("gray.700", "white");
  let inactiveColor = useColorModeValue(
    "secondaryGray.600",
    "secondaryGray.600"
  );
  let activeIcon = useColorModeValue("#364fab", "#364fab");
  let textColor = useColorModeValue("secondaryGray.500", "white");
  let brandColor = useColorModeValue("#364fab", "#364fab");
  let disabledColor = useColorModeValue("gray.300", "gray.600");

  // Routes'u dinamik olarak al (props'tan gelse de güncel routes'u kullan)
  const routes = props.routes || getRoutes();
  const [userPlan, setUserPlan] = useState('STANDARD');

  useEffect(() => {
    const fetchPlan = async () => {
      try {
        const pricingInfo = await pricingService.getPricingInfo();
        if (pricingInfo?.success && pricingInfo?.data?.business?.plan) {
          setUserPlan(pricingInfo.data.business.plan);
        }
      } catch (error) {
        console.error('Plan bilgisi alınamadı:', error);
        const business = JSON.parse(localStorage.getItem('business') || '{}');
        if (business.plan) {
          setUserPlan(business.plan);
        }
      }
    };
    
    fetchPlan();
  }, []);

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    // Business name ile başlayan path'leri de kontrol et
    const pathWithoutBusiness = location.pathname.replace(/^\/admin\/[^/]+/, '/admin');
    return location.pathname.includes(routeName) || pathWithoutBusiness.includes(routeName);
  };

  // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
  const createLinks = (routes) => {
    return routes
      .filter(route => route.showInSidebar)
      .map((route, index) => {
        if (route.category) {
          return (
            <>
              <Text
                fontSize={"md"}
                color={activeColor}
                fontWeight='bold'
                mx='auto'
                ps={{
                  sm: "10px",
                  xl: "16px",
                }}
                pt='18px'
                pb='12px'
                key={index}>
                {route.name}
              </Text>
              {createLinks(route.items)}
            </>
          );
        } else if (
          (route.layout && route.layout.startsWith("/admin")) ||
          route.layout === "/auth"
        ) {
          // Stok Durumu için plan kontrolü
          const isStockRoute = route.path === '/stok-durumu';
          const isDisabled = isStockRoute && userPlan !== 'PREMIUM';
          
          const linkContent = (
            <Box
              opacity={isDisabled ? 0.5 : 1}
              cursor={isDisabled ? 'not-allowed' : 'pointer'}
              pointerEvents={isDisabled ? 'none' : 'auto'}
            >
              {route.icon ? (
                <Box>
                  <HStack
                    spacing={
                      activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                    }
                    py='5px'
                    ps='10px'>
                    <Flex w='100%' alignItems='center' justifyContent='center'>
                      <Box
                        color={
                          isDisabled
                            ? disabledColor
                            : activeRoute(route.path.toLowerCase())
                            ? activeIcon
                            : textColor
                        }
                        me='18px'>
                        {route.icon}
                      </Box>
                      <Text
                        me='auto'
                        color={
                          isDisabled
                            ? disabledColor
                            : activeRoute(route.path.toLowerCase())
                            ? activeColor
                            : textColor
                        }
                        fontWeight={
                          activeRoute(route.path.toLowerCase())
                            ? "bold"
                            : "normal"
                        }>
                        {route.name}
                      </Text>
                      {isDisabled && (
                        <Text fontSize="xs" color="gray.400" ml="auto" mr="8px">
                          PREMIUM
                        </Text>
                      )}
                    </Flex>
                    <Box
                      h='36px'
                      w='4px'
                      bg={
                        activeRoute(route.path.toLowerCase())
                          ? brandColor
                          : "transparent"
                      }
                      borderRadius='5px'
                    />
                  </HStack>
                </Box>
              ) : (
                <Box>
                  <HStack
                    spacing={
                      activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                    }
                    py='5px'
                    ps='10px'>
                    <Text
                      me='auto'
                      color={
                        isDisabled
                          ? disabledColor
                          : activeRoute(route.path.toLowerCase())
                          ? activeColor
                          : inactiveColor
                      }
                      fontWeight={
                        activeRoute(route.path.toLowerCase()) ? "bold" : "normal"
                      }>
                      {route.name}
                    </Text>
                    {!isDisabled && <Box h='36px' w='4px' bg='#364fab' borderRadius='5px' />}
                  </HStack>
                </Box>
              )}
            </Box>
          );

          // URL'yi doğru oluştur - her zaman güncel business slug'ı kullan
          const getLinkPath = () => {
            if (!route.path) return '/';
            
            const businessSlug = getBusinessSlug();
            if (businessSlug) {
              return `/admin/${businessSlug}${route.path}`;
            }
            // Fallback: route.layout kullan (eski sistem için)
            return route.layout ? `${route.layout}${route.path}` : route.path;
          };

          return isDisabled ? (
            <Tooltip key={index} label="Bu özellik PREMIUM plan için geçerlidir" placement="right">
              {linkContent}
            </Tooltip>
          ) : (
            <NavLink key={index} to={getLinkPath()}>
              {linkContent}
            </NavLink>
          );
        }
      });
  };
  //  BRAND
  return createLinks(routes);
}

export default SidebarLinks;